import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import Draggabilly from 'draggabilly';
import isEmpty from 'lodash/isEmpty';
import {Scrollbars} from "react-custom-scrollbars";
import $ from 'jquery'

import Resizer from '../Resizer';
import { PmWindow } from '../PmWindow';
import Registry from '../../../registry';
import * as VirtualWindowManager from '../VirtualWindowManager';
import NotificationListItem from '../NotificationListItem';

class NotificationsWindow extends PmWindow {
    static generateKey = () => 'notifications-window-key';

    static _getListContainer = () => document.getElementById('notifications-window');

    static mount = function(props) {
        const listContainer = NotificationsWindow._getListContainer();
        if (!listContainer) throw new Error('No notification window container found (#notifications-window element)');
    
        const id = NotificationsWindow.generateKey(props);
        let mountElement = listContainer.querySelector('#'+id);
    
        if (!mountElement) {
            mountElement = document.createElement('div');
            mountElement.setAttribute('id', id);
            listContainer.appendChild(mountElement);
        }
    
        return ReactDOM.render(
            React.createElement(NotificationsWindow, props),
            mountElement,
            function() {
                if(props.notifications.showNotificationsWindow)
                    mountElement.classList.add("shown");
                else
                    mountElement.classList.remove("shown");
            }
        );
    };

    minimize() {
        let $window = $(this.ref);
        $window.fadeOut(200, function () {
            $(this).css("display", "");
        });
    }

    maximize() {
        let $window = $(this.ref);
        $window.css("opacity", 0.0).animate({opacity: 1.0}, 200);
    }

    dragMove() {}

    componentDidMount() {
        let { browser } = this.props;
        
        if (browser.desktop) {
            this.draggabilly = new Draggabilly(this.ref, {
                handle: ".text",
                containment: document.body
            });

            this.draggabilly.on('dragMove', this.dragMove);

            this.ref.className += ' virtual-window';
            VirtualWindowManager.register(this.ref);

            this.ref.style.position = 'absolute';
            this.ref.style.left = (window.innerWidth / 2 - 180) + 'px';
            this.ref.style.top = (window.innerHeight / 2 - 235) + 'px';
        }
    }

    componentWillUpdate(nextProps) {
        const prevShow = this.props.notifications.showNotificationsWindow,
            nextShow = nextProps.notifications.showNotificationsWindow;

        // minimize
        if (prevShow && !nextShow) {
            this.minimize();
        }

        // maximize
        if (!prevShow && nextShow) {
            this.maximize();
        }
    }

    componentDidUpdate(prevProps) {
        const prevNotifications = prevProps.notifications,
            { notifications } = this.props;

        if (notifications.list.length > prevNotifications.list.length) {
            this.animatePMChatLog();
        }

        if (notifications.showNotificationsWindow && !prevNotifications.showNotificationsWindow) {
            this.animatePMChatLog();
        }
    }

    render() {
        const { browser, closeNotificationsWindow, notifications: { showNotificationsWindow, list } } = this.props;
        const lang = Registry.get('locale');
        const store = Registry.get('store');
    
        let windowStatus = [];
        if (browser.desktop) windowStatus.push('virtual-window');
        
        if (showNotificationsWindow) {
            windowStatus.push('active')
        } else {
            windowStatus.push('minimized');
        }

        const filteredList = list.filter(item => item.data.visibility === 'personal');

        return (
            <div className={'popup-pm-window notifications allowed ' + windowStatus.join(' ')} ref={ref => this.ref = ref}>
                <div className="top">
                    <div className="fono" />
                        <div className="text">
                        <p className="name">
                            <a href="#">Notifications</a>
                        </p>
                        <span className="minimize" title={lang.minimize_pm} onClick={closeNotificationsWindow} />
                    </div>
                </div>
                <Provider store={store}>
                    <div className="cont">
                        <div className="contents allowed">
                            <div className="chat-mini">
                                <Scrollbars
                                    renderTrackVertical={props => <div {...props} className="track-vertical"/>}
                                    renderThumbVertical={props => <div {...props} className="thumb-vertical"/>}
                                >
                                    <div className="chat-mini-inner" ref={ref => this.chatLog = ref}>
                                        <div className="notification-list">
                                            <div className={`content ${list.length ? 'paddingTop' : ''}`}>
                                                {isEmpty(list) ? (
                                                    <div className="list-empty" >
                                                        {lang.empty_notifications}
                                                    </div>
                                                ) : (
                                                    <div className="list">
                                                        {filteredList.map(notification => <NotificationListItem key={notification.data.id} data={notification} />)}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </Scrollbars>
                            </div>
                        </div>
                    </div>
                </Provider>
                <Resizer target={{ current: this.ref }} />
            </div>
        )
    } 
}

export default NotificationsWindow;



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/NotificationsWindow/index.js